export function removeEmoji(value) {
  // @see https://www.regextester.com/106421
  const regex = /(\u00a9|\u00ae|[\u2000-\u20ab]|[\u20ad-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/
  return value.replace(new RegExp(regex, 'g'), '')
}
